
export default function ComingSoon() {
  return (
    <div className="w-full min-h-[400px] flex flex-col items-center justify-center bg-white border border-gray-200 rounded-xl p-8 my-4 font-sans text-center">
      
      {/* Icon Area */}
      <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center border border-gray-100 mb-4 shadow-sm">
        <span className="text-2xl text-gray-400">🛠️</span>
      </div>

      {/* Text Content */}
      <div className="space-y-2 max-w-sm">
        <h3 className="text-base font-bold text-gray-800 tracking-wide">
          Coming Soon
        </h3>
        <p className="text-xs text-gray-500 leading-relaxed">
          ဤအပိုင်းအတွက် အချက်အလက်ပုံစံနှင့် ဇယားကွက်များအား ထည့်သွင်းရန် ပြင်ဆင်နေဆဲဖြစ်ပါသည်။ မကြာမီ အသုံးပြုနိုင်မည် ဖြစ်ပါသည်။
        </p>
      </div>

      {/* Skeleton Loading Blocks (For Replacement Visual) */}
      <div className="w-full max-w-xs mt-6 space-y-2 opacity-50">
        <div className="h-3 bg-gray-100 rounded-md w-3/4 mx-auto animate-pulse"></div>
        <div className="h-3 bg-gray-100 rounded-md w-1/2 mx-auto animate-pulse"></div>
      </div>

    </div>
  );
}